/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * RapidWorks REST API
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { DefaultPoNumberDto, ProblemDetails } from '.././model';

import { axiosInstance } from '../../axios-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Gets the default PO number and requirement for a given customer and job site.
 */
export const getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId = (
  customerId: number,
  jobSiteId: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<DefaultPoNumberDto>(
    { url: `/api/v3/purchase-orders/default-number/customers/${customerId}/job-sites/${jobSiteId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteIdQueryKey = (
  customerId?: number,
  jobSiteId?: number
) => {
  return [`/api/v3/purchase-orders/default-number/customers/${customerId}/job-sites/${jobSiteId}`] as const;
};

export const getGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
  TError = ProblemDetails | void
>(
  customerId: number,
  jobSiteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteIdQueryKey(customerId, jobSiteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>> = ({
    signal
  }) => getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId(customerId, jobSiteId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(customerId && jobSiteId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>
>;
export type GetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteIdQueryError = ProblemDetails | void;

export function useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId<
  TData = Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
  TError = ProblemDetails | void
>(
  customerId: number,
  jobSiteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId<
  TData = Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
  TError = ProblemDetails | void
>(
  customerId: number,
  jobSiteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId<
  TData = Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
  TError = ProblemDetails | void
>(
  customerId: number,
  jobSiteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets the default PO number and requirement for a given customer and job site.
 */

export function useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId<
  TData = Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>,
  TError = ProblemDetails | void
>(
  customerId: number,
  jobSiteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteIdQueryOptions(
    customerId,
    jobSiteId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
